import { InputTimeMaskWebElementBase } from './InputTimeMaskWebElementBase';
import { getTestElement } from '../../../webdriver/PRIVATE_preact-webdriver';
import { findInputTimeMask } from '@oracle/oraclejet-preact/UNSAFE_InputTimeMask/testing';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

import { DateTimeUtils } from '@oracle/oraclejet-preact/UNSAFE_IntlDateTime';
import { getTimeObjFromTimeOnlyISOStr } from '@oracle/oraclejet-preact/utils/UNSAFE_timeUtils';

/**
 * The component WebElement for [oj-c-input-time-mask](../../jsdocs/oj-c.InputTimeMask.html).
 * Do not instantiate this class directly, instead, use
 * [findInputTimeMask](../functions/findInputTimeMask.html).
 */
export class InputTimeMaskWebElement extends InputTimeMaskWebElementBase {
  // Put overrides here
  /**
   * Sets the value of the "value" property of the input component.
   * @param value The value to set for the <code>value</code>
   */
  public async changeValue(value: string | null): Promise<void> {
    if (!DateTimeUtils.isTimeOnlyIsoString(value)) {
      throw new Error(`InputTimeMaskWebElement - value must be a time-only ISO string: ${value}`);
    }

    const readonly = await this.getReadonly();
    const disabled = await this.getDisabled();
    if (!(disabled || readonly)) {
      const timeValue = getTimeObjFromTimeOnlyISOStr(value);
      // the getTestElement(this) locates the root of the corepack custom element (oj-c-input-time-mask),
      // and byCss('*') finds the first child element underneath the root which is the root of the preact component.
      return findInputTimeMask(byCss('*'), getTestElement(this)).changeValue(timeValue);
    }

    return this.whenBusyContextReady();
  }

  /**
   * Clears the value of the component.
   */
  clear(): Promise<void> {
    return this.changeValue(null);
  }
}
